import { render, staticRenderFns } from "./sale-board.vue?vue&type=template&id=32682139&scoped=true&"
import script from "./sale-board.vue?vue&type=script&lang=js&"
export * from "./sale-board.vue?vue&type=script&lang=js&"
import style0 from "./sale-board.vue?vue&type=style&index=0&id=32682139&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32682139",
  null
  
)

export default component.exports